import axiosInstance from "../../axios";
import router from '../../router' 
const axios = axiosInstance();

export const state = {
    currentUser: localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null, 
    authError: null, 
    documentsWereRejected: null,
    signtureWasRejected: null, 
    userPersonalData: null,  
    verificationEmail: null, 
    registerPsw: null,
    confirmRegisterPsw: null, 
    expireVar: null,
    signatureVar: null,
    idVar: null,
    hashVar: null,

    authLoading: false,
}

export const mutations = {
    setCurrentUser(state, newValue) {
        state.currentUser = newValue
        saveState('user', newValue)
        localStorage.setItem("user", JSON.stringify(newValue));
    },
    setAuthMsg(state, authError) {
        state.authError = authError
    }, 
    setDocumentsWereRejected(state, documentsWereRejected) {
        state.documentsWereRejected = documentsWereRejected
    },
    setSigntureWasRejected(state, signtureWasRejected) {
        state.signtureWasRejected = signtureWasRejected
    }, 
    setUserPersonalData(state, userPersonalData) {
        state.userPersonalData = userPersonalData
    }, 
    setRegisterPsw(state, registerPsw) {
        state.registerPsw = registerPsw
    }, 
    setConfirmRegisterPsw(state, confirmRegisterPsw) {
        state.confirmRegisterPsw = confirmRegisterPsw
    }, 
    setExpireVar(state, expireVar) {
        state.expireVar = expireVar
    }, 
    setSignatureVar(state, signatureVar) {
        state.signatureVar = signatureVar
    }, 
    setIdVar(state, idVar) {
        state.idVar = idVar
    }, 
    setHashVar(state, hashVar) {
        state.hashVar = hashVar
    }, 
    setVerificationEmail(state, verificationEmail) {
        state.verificationEmail = verificationEmail
    },

    setAuthLoading(state, authLoading){
        state.authLoading = authLoading 
    }
}

export const getters = {
    loggedIn(state) {
        return !!state.currentUser
    },
    currentUser: state => state.currentUser,
    authError: state => state.authError, 
    documentsWereRejected: state => state.documentsWereRejected,
    signtureWasRejected: state => state.signtureWasRejected, 
    userPersonalData: state => state.userPersonalData, 
    registerPsw: state => state.registerPsw,
    confirmRegisterPsw: state => state.confirmRegisterPsw, 
    expireVar: state => state.expireVar,
    signatureVar: state => state.signatureVar,
    idVar: state => state.idVar,
    hashVar: state => state.hashVar, 
    verificationEmail: state => state.verificationEmail,
    authLoading: state => state.authLoading,
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    async logIn({ commit }, { email, password } = {}) {
        try {
            const response = await axios.post("/customer/login", {
                email,
                password,
            });

            const { token, customer } = response.data.data;

            if (token && customer) {
                commit('setCurrentUser', customer);
                localStorage.setItem('token', token);
                commit("setAuthMsg", null);
            } else {
                commit("setAuthMsg", 'Ein unerwarteter Fehler ist aufgetreten..');
            }
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },


    async registerStep1({ commit }, newUser) {
        try {
            await axios.post("/customer/register", newUser);
            commit("setAuthMsg", null);
        } catch (error) { 
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten."; 
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },

    async registerStep2({ commit }, { newUser, id, hash, expires, signature }) {
        try {
            const response = await axios.post(`/customer/verify-email/${id}/${hash}?expires=${expires}&signature=${signature}`, newUser); 

            const { token, customer } = response.data;

            if (token && customer) {
                commit('setCurrentUser', customer);
                localStorage.setItem('token', token);
                commit("setAuthMsg", null);
            } else {
                commit("setAuthMsg", 'Ein unerwarteter Fehler ist aufgetreten..');
            }
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },

    async logOut({ commit }) {
        // eslint-disable-next-line no-unused-vars  
        try {
             commit("setAuthLoading", true); 
            const token = localStorage.getItem('token');
 
            if (token) {
                await axiosInstance({ requiresAuth: true }).post("/customer/logout");
            }
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
           // throw new Error(errorMessage);
        } finally {
            commit('setCurrentUser', null);
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            commit("setAuthLoading", false);
            router.push({ name: 'Home' }); 
        }
    },

    async checkUserIdentity({ commit, dispatch, rootState  }) { 
        try {
            commit("setAuthLoading", true);
            const result = await axiosInstance({ requiresAuth: true }).get("/customer/personalData");

            const user = result.data.data;

            if (!user.verified) {
                const isMobile = window.innerWidth <= 694;

                const skipMobile = rootState.application.skipMobileInfoModal; 

                if (user.showSignatureUploadWindow) {
                    if (isMobile && !skipMobile) {
                        commit("application/setMobileInformationModal", true, { root: true });
                    } else {
                        commit("application/setAddSignatureModal", true, { root: true });
                    }

                } else if (user.showDocumentsUploadWindow) {
                    if (isMobile && !skipMobile) {
                        commit("application/setMobileInformationModal", true, { root: true });
                    } else {
                        commit("application/setAddDocumentsModal", true, { root: true });
                    }
                }

               
                else if (user.showSignatureRejectedWindow) {
                    commit("setSigntureWasRejected", true);
                    commit("application/setFailedVerifyModal", true, { root: true });
                } else if (user.showDocumentsRejectedWindow) {
                    commit("setDocumentsWereRejected", true);
                    commit("application/setFailedVerifyModal", true, { root: true });
                } else {
                    commit("application/setDocumentsVerifyModal", true, { root: true });
                }

                router.push({ name: 'Overview' });
                commit("setAuthLoading", false);

                if (skipMobile) {
                    commit("application/setSkipMobileInfoModal", false, { root: true });
                }
            } else {
                commit("setAuthLoading", false);
                return true;
            }
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
 
            commit("application/setErrorProcessModal", true, { root: true });
            commit("application/setErrorProcessTitle", "Beim Einloggen ist ein Fehler aufgetreten!", { root: true });
            commit("application/setErrorProcessText", errorMessage, { root: true });
 
            if (error.response?.status === 401) { 
                await dispatch("logOut");
            }
        }
    },


    async requestCleanData({ commit }) {
        try {
            const response = await axiosInstance({ requiresAuth: true }).post("/customer/requestCleanData");
            return response.data;
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },


    async getProfilelData({ commit }) {
        try {
            const result = await axiosInstance({ requiresAuth: true }).get("/customer/personalData");
            commit("setUserPersonalData", result.data.data);

        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },


    async requestPasswordChange({ commit }, email) {
        try {
            await axios.post("/customer/forgot-password", { email });
            commit("setAuthMsg", null);
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    },

    async resetPassword({ commit }, data) {
        try {
            const response = await axios.post('/customer/reset-password', data);

            const { token, customer } = response.data;
            if (token && customer) {
                commit('setCurrentUser', customer);
                localStorage.setItem('token', token);
                commit("setAuthMsg", null);
            } else {
                commit("setAuthMsg", 'Ein unerwarteter Fehler ist aufgetreten..');
            }
        } catch (error) {
            const data = error.response?.data;
            const errorMessage = typeof data === "string" ? data : data?.message || "Ein unerwarteter Fehler ist aufgetreten.";
            commit("setAuthMsg", errorMessage);
            throw new Error(errorMessage);
        }
    }
}

function saveState(key, state) {
    window.sessionStorage.setItem(key, JSON.stringify(state))
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
